import { NavHashLink } from 'react-router-hash-link';
import styled from 'styled-components';

import Row from 'components/Row';

export const NavLink = styled(NavHashLink)`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: center;
  align-items: center;

  padding: 6px 12px;
  border-radius: ${({ theme }) => theme.spacings.abs8}px;
  background: ${({ theme }) => theme.colors.grey(4)};
  color: ${({ theme }) => theme.colors.grey(-1)};
  line-height: 22px;
  font-weight: 500;

  :hover {
    background: ${({ theme }) => theme.colors.grey(3)};
  }
`;

export const NavigationMenuContainer = styled(Row)`
  justify-content: center;
  position: sticky;
  width: 65%;
  top: 0;
  z-index: 10;

  backdrop-filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.9);

  padding-top: ${({ theme }) => theme.spacings.abs24}px;
  padding-bottom: ${({ theme }) => theme.spacings.abs16}px;
  margin: auto;
  & > *:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacings.abs8}px;
  }
`;
